module.exports = __webpack_public_path__ + "img/course-7.d765ad14.jpeg";